import {
  Box,
  Card,
  CardMedia,
  Collapse,
  Divider,
  Grid,
  IconButton,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableRow,
  Tooltip,
  Typography,
  TableHead,
  TableCell
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { formatter, getPrice, getQuantity } from '../../utils/auxFunc'
import DeleteIcon from '@mui/icons-material/Delete'
import { Fragment, useState } from 'react'
import { withStyles } from '@mui/styles'
import ItemCount from '../ItemCount'
import { getQuantityByProduct, getSizesByColor } from '../../utils/auxFunc'

const CartTableCell = withStyles({
  root: {
    borderBottom: 'none'
  }
})(TableCell)

// const ActionsButtons = styled(Button)({
// 	padding: "0",
// 	minHeight: "24px",
// });

const ExpandMore = styled((props) => {
  const { expand, ...other } = props
  return <IconButton {...other} />
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  padding: '0 0.5rem',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest
  })
}))

const CartItemList = ({
  product,
  removeByProductId,
  removeByComponentId,
  addToComponent,
  removeToComponent
}) => {
  const [expanded, setExpanded] = useState(false)

  const sizeAndQuantityByColor = getSizesByColor(product)
  const quantity = getQuantityByProduct(sizeAndQuantityByColor)

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  return (
    <Fragment>
      <Box key={product.idProduct} maxWidth="sm" margin="0 auto">
        <Grid container columnSpacing={1} my={2}>
          <Grid item xs={2} lg={2} display="flex" alignItems="center">
            <Card sx={{ width: '100%', borderRadius: '5px' }}>
              <CardMedia
                component="img"
                alt={product.name}
                image={product.components[0].img}
                pt={0}
              ></CardMedia>
            </Card>
          </Grid>
          <Grid
            item
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            xs={6}
            lg={8}
          >
            <Box>
              <Typography
                variant="subtitle1"
                sx={{
                  textTransform: 'capitalize',
                  lineHeight: 1.25,
                  my: 0.5
                }}
              >
                {product.name}
              </Typography>
              <Typography variant="caption">
                {`${quantity}` > 1
                  ? `${quantity} artículos`
                  : `${quantity} artículo`}
              </Typography>
            </Box>
            <Box
              onClick={handleExpandClick}
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center'
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  textTransform: 'capitalize',
                  lineHeight: 1.25
                }}
                color="secondary"
              >
                Editar
              </Typography>
              <ExpandMore
                expand={expanded}
                aria-expanded={expanded}
                aria-label="editar compra"
              >
                <ExpandMoreIcon />
              </ExpandMore>
            </Box>
          </Grid>
          <Grid
            item
            display="flex"
            flexDirection="column"
            alignItems="flex-end"
            justifyContent="space-between"
            xs={4}
            lg={2}
          >
            <Box>
              <Typography
                variant="subtitle1"
                sx={{
                  textTransform: 'capitalize',
                  lineHeight: 1.25,
                  my: 0.5,
                  textAlign: 'end'
                }}
              >
                {formatter().format(
                  getPrice(
                    product.volumePrices,
                    product.price,
                    getQuantity(product)
                  ) *
                    product.dolarValue *
                    quantity
                )}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  textTransform: 'capitalize'
                }}
              >
                un.{' '}
                {formatter().format(
                  getPrice(
                    product.volumePrices,
                    product.price,
                    getQuantity(product)
                  ) * product.dolarValue
                )}
              </Typography>
            </Box>
            <Tooltip title="Borrar" placement="bottom">
              <IconButton
                aria-label="delete"
                sx={{
                  alignItems: 'flex-start',
                  padding: 0,
                  minHeight: '24px'
                }}
                onClick={() => removeByProductId(product.idProduct)}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12}>
            <Collapse
              in={expanded}
              timeout="auto"
              unmountOnExit
              sx={{ width: '100%', mt: '0.5rem' }}
            >
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <CartTableCell align="center" width="42%">
                        <Typography variant="captions" color="secondary">
                          Color
                        </Typography>
                      </CartTableCell>
                      <CartTableCell align="center" width="42%">
                        <Typography variant="captions" color="secondary">
                          Unidades
                        </Typography>
                      </CartTableCell>
                      <CartTableCell align="center" width="16%"></CartTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sizeAndQuantityByColor?.map((element) => {
                      let rowSpan = element.types.length
                      let firstRow = element.types.slice(0, 1)
                      let restRows = element.types.slice(1)

                      return (
                        <Fragment key={firstRow[0].idComponent}>
                          <TableRow
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                          >
                            <CartTableCell
                              scope="row"
                              width="42%"
                              rowSpan={rowSpan}
                              sx={{ verticalAlign: 'center' }}
                            >
                              <Typography
                                variant="subtitle1"
                                color="initial"
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  textTransform: 'capitalize'
                                }}
                              >
                                {element.descriptionColor}
                              </Typography>
                            </CartTableCell>
                            <CartTableCell align="center" width="42%">
                              <ItemCount
                                component={firstRow[0]}
                                initial={firstRow[0].quantity}
                                addToComponent={addToComponent}
                                removeToComponent={removeToComponent}
                                removeByComponentId={removeByComponentId}
                              />
                            </CartTableCell>
                            <CartTableCell
                              align="right"
                              width="16%"
                              sx={{ padding: '6px 12px' }}
                            >
                              <Tooltip title="Borrar" placement="bottom">
                                <IconButton
                                  aria-label="delete"
                                  onClick={() => {
                                    removeByComponentId({
                                      idProduct: product.idProduct,
                                      idComponent: firstRow[0].idComponent
                                    })
                                  }}
                                  sx={{
                                    alignItems: 'flex-start',
                                    padding: 0
                                  }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            </CartTableCell>
                          </TableRow>
                          {restRows?.map((row) => {
                            return (
                              <TableRow
                                key={row.idComponent}
                                sx={{
                                  '&:last-child td, &:last-child th': {
                                    border: 0
                                  }
                                }}
                              >
                                <CartTableCell align="center" width="16%">
                                  {row.size}
                                </CartTableCell>
                                <CartTableCell align="center" width="43%">
                                  <ItemCount
                                    component={row}
                                    initial={row.quantity}
                                    addToComponent={addToComponent}
                                    removeToComponent={removeToComponent}
                                    removeByComponentId={removeByComponentId}
                                  />
                                </CartTableCell>
                                <CartTableCell
                                  align="right"
                                  width="16%"
                                  sx={{ padding: '6px 12px' }}
                                >
                                  <Tooltip title="Borrar" placement="bottom">
                                    <IconButton
                                      aria-label="delete"
                                      onClick={() =>
                                        removeByComponentId({
                                          idProduct: product.idProduct,
                                          idComponent: row.idComponent
                                        })
                                      }
                                      sx={{
                                        alignItems: 'flex-start',
                                        padding: 0
                                      }}
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </Tooltip>
                                </CartTableCell>
                              </TableRow>
                            )
                          })}
                        </Fragment>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Collapse>
          </Grid>
        </Grid>
        <Divider />
      </Box>
    </Fragment>
  )
}

export default CartItemList
